//default from angular libraries
import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';

//import services
import { SuperAdminService } from '../../../../services/superadmin.service';


@Component({
  selector: 'app-super_package-details',
  templateUrl: './package-details.component.html',
  styleUrls: ['./package-details.component.css'],
  host: {'id': 'content'},
  providers: [SuperAdminService]
})

export class PackageDetailsComponent implements OnInit {
    id:string = ""
    userdata:any;
    timetable:boolean;
    servicing:boolean;
    human_resource:boolean;
    mesurement_tool:boolean;
    problem_solving:boolean;
    doc_management:boolean;
    clients:boolean;
    consultancy:boolean;
    academy:boolean;
    project:boolean;
    audit:boolean;


  	constructor(
          private route: ActivatedRoute,
          private router: Router,
          private superadminService : SuperAdminService  
    ) { }

  	ngOnInit() {
        this.id = this.route.snapshot.paramMap.get('id');
        this.getUserData(this.id)
    }
    
    getUserData(id){
        this.superadminService.getPackageDetail(id).subscribe(
            (res) => {
                console.log(res)
                if(res.status){                    
                    this.userdata = res.data.user_data
                    this.timetable = (this.userdata.timetable == 1 || this.userdata.timetable == "1")?false:true;
                    this.servicing = (this.userdata.servicing == 1 || this.userdata.servicing == "1")?false:true;
                    this.human_resource =  (this.userdata.human_resource == 1 || this.userdata.human_resource == "1")?false:true;
                    this.mesurement_tool = (this.userdata.mesurement_tool == 1 || this.userdata.mesurement_tool == "1")?false:true;
                    this.problem_solving = (this.userdata.problem_solving == 1 || this.userdata.problem_solving == "1")?false:true;
                    this.doc_management = (this.userdata.doc_management == 1 || this.userdata.doc_management == "1")?false:true;
                    this.clients = (this.userdata.clients == 1 || this.userdata.clients == "1")?false:true;
                    this.consultancy = (this.userdata.consultancy == 1 || this.userdata.consultancy == "1")?false:true;
                    this.academy = (this.userdata.academy == 1 || this.userdata.academy == "1")?false:true;
                    this.project = (this.userdata.project == 1 || this.userdata.project == "1")?false:true;
                    this.audit = (this.userdata.audit == 1 || this.userdata.audit == "1")?false:true;                    
                }
            }
        );
    }

}
